import React from 'react';
import { Helmet } from 'react-helmet';

interface SEOProps {
  title?: string;
  description?: string;
}

const DEFAULT_TITLE = 'TikTok API for Business';
const DEFAULT_DESCRIPTION = 'TikTok API for Business is a series of interface services provided by TikTok for Business to developers. '
  + 'Through integrating and calling the TikTok API for Business interface, developers can leverage our interface to interact '
  + 'interact with TikTok Ads Manager, TikTok Accounts and TikTok Creator Marketplace functionalities.';

const SEO: React.FC<SEOProps> = ({
  title,
  description,
}) => {
  const pageTitle = title ? `${title} - ${DEFAULT_TITLE}` : DEFAULT_TITLE;
  const pageDescription = description || DEFAULT_DESCRIPTION;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
    </Helmet>
  );
};

export default SEO;
